import { Box, Grid, InputLabel, FormControl, FormControlLabel, Switch, Grow } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

// ------------------COMPONENTS-----------------------
import Assigned from "../Dropdowns/Assigned/Assigned";
import Declarative from "../Dropdowns/Declarative/Declarative";
import BreakdownEffect from "../Dropdowns/BreakdownEffect/BreakdownEffect";
import BreakdownReasonGroup from "../Dropdowns/BreakdownReasonGroup/BreakdownReasonGroup";
import CostCenter from "../Dropdowns/CostCenter/CostCenter";
import AreaGroup from "../Dropdowns/AreaGroup/AreaGroup";
import TaskNo from "../TextFields/TaskNo/TaskNo";
import CallNo from "../TextFields/CallNo/CallNo";
import PlanNo from "../TextFields/PlanNo/PlanNo";
import MaintenanceNote from "../TextFields/MaintenanceNote/MaintenanceNote";
import CallNote from "../TextFields/CallNote/CallNote";
import PlanNote from "../TextFields/PlanNote/PlanNote";
import Machine from "../TextFields/Machine/Machine";
import StartDate from "../StartDate/StartDate";
import EndDate from "../EndDate/EndDate";
import Status from "../Status/Status";
import Pool from "../Pool/Pool";
import MaintenanceType from "../Dropdowns/MaintenanceType/MaintenanceType";
import RecordStatus from "../Dropdowns/RecordStatus/RecordStatus";
import EnvironmentalCompliance from "../Dropdowns/EnvironmentalCompliance/EnvironmentalCompliance";
import DateInterval from "../DateInterval/DateInterval";

import { TextField, Autocomplete, Paper } from "@mui/material";
import BreakdownReasonPlace from "../Dropdowns/BreakdownReasonPlace/BreakdownReasonPlace";
import BreakdownRootCause from "../Dropdowns/BreakdownRootCause/BreakdownRootCause";
import MaintenanceTypeData from "../Dropdowns/MaintenanceType/MaintenanceTypeData";
import LateCheckbox from "../Dropdowns/LateCheckbox/LateCheckbox";
import OrderForm from "../Dropdowns/OrderForm/OrderForm";
import { isMobile } from "react-device-detect";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { tr } from "date-fns/esm/locale";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import GenericDatePicker from "../../components/GenericDatePicker/GenericDatePicker";

function DetailFilter(props) {
    const { t } = useTranslation("translation");

    return (
        <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
            <Box sx={{ width: 300, padding: 1, marginTop: 1 }} role="presentation">
                <form>
                    <Grid>
                        {props.HandleAssignToMe ? (
                            <Grid id="bl_Grid_3" item style={{ display: "flex", justifyContent: "center" }}>
                                <FormControlLabel
                                    id="bl_formControl_2"
                                    control={
                                        <Switch
                                            id="bl_CheckMe"
                                            checked={props.checkedMe}
                                            onChange={props.HandleAssignToMe}
                                            color="primary"
                                            name="checkedMe"
                                            inputProps={{ "aria-label": "controlled" }}
                                        />
                                    }
                                    label={t("OnMe")}
                                />
                            </Grid>
                        ) : null}

                        {props.HandleRowLength ? (
                            !isMobile ? (
                                <Grid id="bl_grid_6" item>
                                    <FormControl id="bl_formControl_11" variant="outlined" fullWidth>
                                        <TextField
                                            size="small"
                                            label={t("CardsPerRow")}
                                            inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                                            onChange={props.HandleRowLength}
                                            onInput={(e) => {
                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 12);
                                                if (e.target.value == "NaN") {
                                                    e.target.value = "";
                                                }
                                            }}
                                        />
                                    </FormControl>
                                    <Box m={3} />
                                </Grid>
                            ) : null
                        ) : null}
                        {props.HandleStatus ? (
                            <Grid item alignItems="center">
                                <FormControl id="DetailFilter_FormControl_1" variant="outlined" fullWidth>
                                    <InputLabel id="DetailFilter_InputLabel" size="small">
                                        {t("Status")}
                                    </InputLabel>
                                    <Status HandleStatus={props.HandleStatus} statusData={props.statusData} status={props.status} selectedStatusName={props.selectedStatusName} size="small" />
                                </FormControl>
                                <Box m={1} />
                            </Grid>
                        ) : null}

                        {props.HandleLate ? (
                            <Grid item>
                                <FormControl id="detailFilter_FormControl_14" variant="outlined" fullWidth>
                                    <LateCheckbox late={props.late} HandleLate={props.HandleLate} size="small" />
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleTimeInterval && props.selectedTimeInterval === 4 ? (
                            <>
                                <Box m={2} />
                                <Grid item>
                                    <FormControl id="detailFilter_FormControl_Time" variant="outlined" fullWidth>
                                        <InputLabel>{t("Time")}</InputLabel>
                                        <DateInterval
                                            HandleTimeInterval={props.HandleTimeInterval}
                                            selectedTimeInterval={props.selectedTimeInterval}
                                            timeIntervals={props.timeIntervals}
                                            size="small"
                                        />
                                    </FormControl>
                                </Grid>
                                <Box m={2} />
                                <Grid item>
                                    <FormControl id="detailFilter_FormControl_StartDate" variant="outlined" fullWidth>
                                        <StartDate id="detailFilter_FormControl_StartDate" HandleStartDate={props.HandleStartDate} startDate={props.startDate} maxDate={props.endDate} size="small" />
                                    </FormControl>
                                </Grid>
                                <Box m={2} />
                                <Grid item>
                                    <FormControl id="detailFilter_FormControl_EndDate" variant="outlined" fullWidth>
                                        <EndDate HandleEndDate={props.HandleEndDate} startDate={props.startDate} endDate={props.endDate} minDate={props.startDate} size="small" />
                                    </FormControl>
                                </Grid>
                                <Box m={2} />
                            </>
                        ) : props.HandleTimeInterval ? (
                            <Grid item>
                                <Box m={3} />
                                <FormControl id="detailFilter_FormControl_Time" variant="outlined" fullWidth>
                                    <InputLabel>{t("Time")}</InputLabel>
                                    <DateInterval HandleTimeInterval={props.HandleTimeInterval} selectedTimeInterval={props.selectedTimeInterval} timeIntervals={props.timeIntervals} size="small" />
                                </FormControl>
                                <Box m={1} />
                            </Grid>
                        ) : null}

                        {props.HandleStartDate && !props.HandleTimeInterval ? (
                            <Grid item>
                                <FormControl id="detailFilter_FormControl_StartDate" variant="outlined" fullWidth>
                                    <StartDate HandleStartDate={props.HandleStartDate} startDate={props.startDate} size="small" />
                                </FormControl>
                                <Box m={2} />
                            </Grid>
                        ) : null}

                        {props.HandleEndDate && !props.HandleTimeInterval ? (
                            <Grid item>
                                <FormControl id="detailFilter_FormControl_EndDate" variant="outlined" fullWidth>
                                    <EndDate HandleEndDate={props.HandleEndDate} startDate={props.startDate} endDate={props.endDate} size="small" />
                                </FormControl>
                                <Box m={2} />
                            </Grid>
                        ) : null}

                        {props.HandleInterventionDateStart ? (
                            <Grid item>
                                <Box m={2} />
                                <FormControl id="detailFilter_FormControl_EndDate" variant="outlined" fullWidth>
                                    <GenericDatePicker
                                        id="interventionDateStart"
                                        dateValue={props.interventionDateStart || null}
                                        onDateChange={props.HandleInterventionDateStart}
                                        label={t("InterventionDateStart")}
                                        size="small"
                                        minDateTime={null}
                                        minDate={null}
                                    />
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleInterventionDateEnd ? (
                            <Grid item>
                                <Box m={2} />
                                <FormControl id="detailFilter_FormControl_EndDate" variant="outlined" fullWidth>
                                    <LocalizationProvider id="pmd_muiPickersUtilProvider" dateAdapter={AdapterDateFns} adapterLocale={tr}>
                                        <GenericDatePicker
                                            id="interventionDateEnd"
                                            dateValue={props.interventionDateEnd || null}
                                            onDateChange={props.HandleInterventionDateEnd}
                                            label={t("InterventionDateEnd")}
                                            size="small"
                                            minDateTime={props.interventionDateStart}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleSparePartUsageStartDate ? (
                            <Grid item>
                                <Paper elevation={2}>
                                    <Grid item style={{ marginLeft: 10, fontWeight: "bold" }}>
                                        {t("SparePartUsageDate")}
                                    </Grid>
                                    <Box m={2} />
                                    <FormControl id="detailFilter_FormControl_15" variant="outlined" fullWidth>
                                        <StartDate
                                            HandleStartDate={props.HandleSparePartUsageStartDate}
                                            startDate={props.usageStartDate}
                                            maxDate={props.maxDate}
                                            minDate={props.minDate}
                                            size="small"
                                        />
                                    </FormControl>
                                    <Box m={3} />
                                    <FormControl id="detailFilter_FormControl_10" variant="outlined" fullWidth>
                                        <EndDate
                                            HandleEndDate={props.HandleSparePartUsageEndDate}
                                            startDate={props.usageStartDate}
                                            endDate={props.usageEndDate}
                                            maxDate={props.maxDate}
                                            minDate={props.minDate}
                                            size="small"
                                        />
                                    </FormControl>
                                    <Box m={1} />
                                </Paper>
                            </Grid>
                        ) : null}

                        {props.HandleShift ? (
                            <Grid item>
                                <FormControl id="DetailFilter_FormControl_Shift" variant="outlined" fullWidth>
                                    <Autocomplete
                                        id="cpm_Shift_Autocomplete"
                                        multiple
                                        options={props.shiftData}
                                        limitTags={5}
                                        value={props.shiftData.filter((item) => props.shiftIds.includes(item.shiftNo))}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) => option.shiftNo}
                                        renderInput={(params) => <TextField id="cpm_TextField_5" {...params} margin="normal" label={t("Shift")} variant="outlined" />}
                                        onChange={(event, newValue) => {
                                            props.HandleShift(newValue);
                                        }}
                                        renderOption={(_props, option) => <li {..._props}>{option.shiftNo}</li>}
                                        size="small"
                                    />
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleAreaFilterChange ? (
                            <Grid item>
                                <FormControl id="DetailFilter_FormControl_8" variant="outlined" fullWidth>
                                    <AreaGroup
                                        HandleAreaFilterChange={props.HandleAreaFilterChange}
                                        areaData={props.areaData}
                                        selectedAreaFilter={props.selectedAreaFilter}
                                        isMultipleAreaGroup={props.isMultipleAreaGroup}
                                        size="small"
                                    />
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleEquipmentGroup ? (
                            <Grid item>
                                <FormControl id="DetailFilter_FormControl_EquipmentGroup" variant="outlined" fullWidth>
                                    <Autocomplete
                                        id="EquipmentGroup_Autocomplete"
                                        multiple
                                        options={props.equipmentGroupData}
                                        limitTags={5}
                                        value={props.equipmentGroupData.filter((item) => props.selectedEquipmentGroup?.includes(item.value))}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) => option.name}
                                        renderInput={(params) => <TextField id="EquipmentGroup_TextField_5" {...params} margin="normal" label={t("EquipmentReportGroup")} variant="outlined" />}
                                        onChange={(event, newValue) => {
                                            props.HandleEquipmentGroup(newValue);
                                        }}
                                        renderOption={(_props, option) => <li {..._props}>{option.name}</li>}
                                        size="small"
                                    />
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.setMachineStates ? (
                            <Grid item>
                                <Machine setMachineStates={props.setMachineStates} machineStates={props.machineStates} isAreaNotFiltered={props.isAreaNotFiltered} size="small" />
                            </Grid>
                        ) : null}

                        {props.setMachineStatesEwo && props.fromPage !== "breakdownDetail" ? (
                            <Grid item>
                                <Machine setMachineStates={props.setMachineStatesEwo} machineStates={props.machineStates} isAreaNotFiltered={props.isAreaNotFiltered} size="small" />
                            </Grid>
                        ) : null}

                        {props.HandlePool ? (
                            <Grid item>
                                <FormControl id="DetailFilter_FormControl_2" variant="outlined" fullWidth>
                                    <Pool HandlePool={props.HandlePool} poolData={props.poolData} poolIds={props.poolIds} size="small" />
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleBreakdownReasonGroup ? (
                            <Grid item>
                                <FormControl id="DetailFilter_FormControl_6" variant="outlined" fullWidth>
                                    <BreakdownReasonGroup
                                        HandleBreakdownReasonGroup={props.HandleBreakdownReasonGroup}
                                        breakdownReasonGroupData={props.breakdownReasonGroupData}
                                        breakdownReasonGroup={props.breakdownReasonGroup}
                                        size="small"
                                    />
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleEwoBreakdownGroup ? (
                            <Grid item>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        props.HandleEwoBreakdownGroup(newValue);
                                    }}
                                    size={"small"}
                                    options={props.breakdownReasonGroupData}
                                    value={props.breakdownReasonGroupName}
                                    renderInput={(params) => <TextField {...params} margin="normal" label={t("BreakdownGroup")} variant="outlined" />}
                                    renderOption={(_props, option) => <li {..._props}>{option.breakdownReasonGroupLocalizationName}</li>}
                                />
                            </Grid>
                        ) : null}

                        {props.HandleRootCauseFamilies ? (
                            <Grid item>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        props.HandleRootCauseFamilies(newValue);
                                    }}
                                    size={"small"}
                                    options={props.rootCauseFamilyData}
                                    value={props.rootCauseFamilyName}
                                    renderInput={(params) => <TextField {...params} margin="normal" label={t("RootCauseFamilies")} variant="outlined" />}
                                    renderOption={(_props, option) => <li {..._props}>{option.rootCausesFamilyName}</li>}
                                />
                            </Grid>
                        ) : null}

                        {props.HandleRootCauseFamilyOptions ? (
                            <Grid item>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        props.HandleRootCauseFamilyOptions(newValue);
                                    }}
                                    disabled={props.isDisabledRootCauseFamilyOptions}
                                    size={"small"}
                                    options={props.rootCauseFamilyOptionsData}
                                    value={props.rootCauseFamilyOptionName}
                                    renderInput={(params) => <TextField {...params} margin="normal" label={t("RootCauseFamilyOptions")} variant="outlined" />}
                                    renderOption={(_props, option) => <li {..._props}>{option.options}</li>}
                                />
                            </Grid>
                        ) : null}

                        {props.HandleVerifiedBy ? (
                            <Grid item>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        props.HandleVerifiedBy(newValue);
                                    }}
                                    size={"small"}
                                    options={props.techData}
                                    value={props.verifiedTechnicianName}
                                    renderInput={(params) => <TextField {...params} margin="normal" label={t("VerifiedBy")} variant="outlined" />}
                                    renderOption={(_props, option) => <li {..._props}>{option.userName}</li>}
                                />
                            </Grid>
                        ) : null}

                        {props.HandleExecutedBy ? (
                            <Grid item>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        props.HandleExecutedBy(newValue);
                                    }}
                                    size={"small"}
                                    options={props.techData}
                                    value={props.executedTechnicianName}
                                    renderInput={(params) => <TextField {...params} margin="normal" label={t("ExecutedBy")} variant="outlined" />}
                                    renderOption={(_props, option) => <li {..._props}>{option.userName}</li>}
                                />
                            </Grid>
                        ) : null}

                        {props.HandleClosureDateStart ? (
                            <Grid item>
                                <Box m={2} />
                                <FormControl id="detailFilter_FormControl_EndDate" variant="outlined" fullWidth>
                                    <LocalizationProvider id="pmd_muiPickersUtilProvider" dateAdapter={AdapterDateFns} adapterLocale={tr}>
                                        <DatePicker
                                            id="bl_table_DatePicker _13"
                                            renderInput={(_props) => <TextField {..._props} size="small" />}
                                            value={props.closureDateStart || null}
                                            label={t("ClosureDateStart")}
                                            onChange={props.HandleClosureDateStart}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleClosureDateEnd ? (
                            <Grid item>
                                <Box m={2} />
                                <FormControl id="detailFilter_FormControl_EndDate" variant="outlined" fullWidth>
                                    <LocalizationProvider id="pmd_muiPickersUtilProvider" dateAdapter={AdapterDateFns} adapterLocale={tr}>
                                        <DatePicker
                                            id="bl_table_DatePicker _13"
                                            renderInput={(_props) => <TextField {..._props} size="small" />}
                                            value={props.closureDateEnd || null}
                                            label={t("ClosureDateEnd")}
                                            onChange={props.HandleClosureDateEnd}
                                            minDate={props.closureDateStart}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleBreakdownReasonPlace ? (
                            <Grid item>
                                <FormControl id="DetailFilter_FormControl_10" variant="outlined" fullWidth>
                                    <BreakdownReasonPlace
                                        HandleBreakdownReasonPlace={props.HandleBreakdownReasonPlace}
                                        breakdownReasonPlaceData={props.breakdownReasonPlaceData}
                                        breakdownReasonPlace={props.breakdownReasonPlace}
                                        size="small"
                                    />
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleMaintenanceType ? (
                            <Grid item>
                                <FormControl id="DetailFilter_FormControl_12" variant="outlined" fullWidth>
                                    <MaintenanceTypeData
                                        HandleMaintenanceType={props.HandleMaintenanceType}
                                        maintenanceTypeData={props.maintenanceTypeData}
                                        maintenanceType={props.maintenanceType}
                                        size="small"
                                    />
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleBreakdownEffect ? (
                            <Grid item>
                                <FormControl id="DetailFilter_FormControl_5" variant="outlined" fullWidth>
                                    <BreakdownEffect
                                        HandleBreakdownEffect={props.HandleBreakdownEffect}
                                        breakdownEffectData={props.breakdownEffectData}
                                        breakdownEffect={props.breakdownEffect}
                                        size="small"
                                    />
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleCostCenterChange ? (
                            <Grid item>
                                <FormControl id="DetailFilter_FormControl_7" variant="outlined" fullWidth>
                                    <CostCenter
                                        HandleCostCenterChange={props.HandleCostCenterChange}
                                        isNotMultipleCostCenter={props.isNotMultipleCostCenter}
                                        costCenterData={props.costCenterData}
                                        selectedCostCenterId={props.selectedCostCenterId}
                                        size="small"
                                    />
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleMaterialDescription ? (
                            <Grid item>
                                <Autocomplete
                                    id="df_MaterialDescription"
                                    onChange={(event, newValue) => {
                                        props.HandleMaterialDescription(newValue);
                                    }}
                                    value={!props.selectedMaterialDescName || props.selectedMaterialDescName === "null" ? null : props.selectedMaterialDescName}
                                    // options with key
                                    options={props.materialDescsName}
                                    getOptionLabel={(option) => option}
                                    //options={props.materialDescData.map((option, index) => option.name)}
                                    renderInput={(params) => <TextField id="bl_table_TextField_1" {...params} margin="normal" label={t("MaterialDescription")} variant="outlined" size="small" />}
                                    size={props.size ?? "normal"}
                                />
                            </Grid>
                        ) : null}

                        {props.HandleRecordStatusChange ? (
                            <Grid item>
                                <FormControl id="DetailFilter_FormControl_RecordStatus" variant="outlined" fullWidth>
                                    <RecordStatus HandleRecordStatusChange={props.HandleRecordStatusChange} recordStatusList={props.recordStatusList} recordStatus={props.recordStatus} size="small" />
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleUser ? (
                            <Grid item>
                                <FormControl id="DetailFilter_FormControl_3" variant="outlined" fullWidth>
                                    <Assigned HandleUser={props.HandleUser} userName={props.userName} userData={props.userData} isMultipleAssigned={props.isMultipleAssigned} size="small" />
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleCreatorName ? (
                            <Grid item>
                                <FormControl id="DetailFilter_FormControl_4" variant="outlined" fullWidth>
                                    <Declarative
                                        HandleCreatorName={props.HandleCreatorName}
                                        creatorName={props.creatorName}
                                        userData={props.userData}
                                        isMultipleDeclarative={props.isMultipleDeclarative}
                                        size="small"
                                    />
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleBreakdownRootCause ? (
                            <Grid item>
                                <FormControl id="DetailFilter_FormControl_11" variant="outlined" fullWidth>
                                    <BreakdownRootCause
                                        HandleBreakdownRootCause={props.HandleBreakdownRootCause}
                                        breakdownRootCauseData={props.breakdownRootCauseData}
                                        breakdownRootCause={props.breakdownRootCause}
                                        size="small"
                                    />
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleMaintenanceTypeChange ? (
                            <Grid item>
                                <FormControl id="DetailFilter_FormControl_9" variant="outlined" fullWidth>
                                    <MaintenanceType
                                        multiple={props.maintenanceTypeMultiple}
                                        HandleMaintenanceTypeChange={props.HandleMaintenanceTypeChange}
                                        maintenanceTypes={props.maintenanceTypes}
                                        selectedMaintenanceTypeName={props.selectedMaintenanceTypeName}
                                        size="small"
                                    />
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.FilterWithID ? (
                            <Grid item>
                                <TaskNo FilterWithID={props.FilterWithID} taskId={props.taskId} size="small" />
                            </Grid>
                        ) : null}

                        {props.FilterOrderId ? (
                            <Grid item>
                                <CallNo FilterOrderId={props.FilterOrderId} selectedMaintenanceOrderId={props.selectedMaintenanceOrderId} size="small" />
                            </Grid>
                        ) : null}

                        {props.FilterPlanId ? (
                            <Grid item>
                                <PlanNo FilterPlanId={props.FilterPlanId} planId={props.selectedPlanId} size="small" />
                            </Grid>
                        ) : null}

                        {props.FilterWithMaintenanceNote ? (
                            <Grid item>
                                <MaintenanceNote FilterWithMaintenanceNote={props.FilterWithMaintenanceNote} maintenanceNote={props.maintenanceNote} size="small" />
                            </Grid>
                        ) : null}

                        {props.FilterWithCallNote ? (
                            <Grid item>
                                <CallNote FilterWithCallNote={props.FilterWithCallNote} callNote={props.callNote} size="small" />
                            </Grid>
                        ) : null}

                        {props.FilterWithPlanNote ? (
                            <Grid item>
                                <PlanNote FilterWithPlanNote={props.FilterWithPlanNote} planNote={props.planNote} size="small" />
                            </Grid>
                        ) : null}

                        {props.handleEnvironmentalComplianceChange ? (
                            <Grid item>
                                <FormControl id="DetailFilter_FormControl_EnvironmentalCompliance" variant="outlined" fullWidth>
                                    <EnvironmentalCompliance isEnvNotClean={props.isEnvNotClean} handleEnvironmentalComplianceChange={props.handleEnvironmentalComplianceChange} size="small" />
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleHasOrderPlaced ? (
                            <Grid item>
                                <FormControl id="DetailFilter_FormControl_OrderForm" variant="outlined" fullWidth>
                                    <OrderForm hasOrderPlaced={props.hasOrderPlaced} HandleHasOrderPlaced={props.HandleHasOrderPlaced} size="small" />
                                </FormControl>
                            </Grid>
                        ) : null}

                        {props.HandleTotalTime ? (
                            <Grid item>
                                <Box m={1} />
                                <FormControl id="detailFilter_FormControl_TotalTime" variant="outlined" fullWidth>
                                    <TextField
                                        id="detailFilter_FormControl_TotalTime"
                                        onChange={props.HandleTotalTime}
                                        defaultValue={props.totalTime}
                                        value={props.totalTime}
                                        label={t("TotalTime")}
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 12);
                                        }}
                                    />
                                </FormControl>
                                <Box m={1} />
                            </Grid>
                        ) : null}

                        <Box m={2} />
                    </Grid>
                </form>
            </Box>
        </Grow>
    );
}

export default DetailFilter;
